<template>
    <div class="content_div">
        <el-card>
            <!-- 搜索区域 -->
            <el-form :inline="true" :model="query" class="demo-form-inline" style="margin-bottom: 20px;">
                <el-form-item label="商品名称">
                    <el-input clearable class="input_class" v-model="query.goodsName" auto-complete="off" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="商品分类">
                    <el-select v-model="query.categoryId" placeholder="请选择分类" clearable>
                        <el-option label="全部分类" value=""/>
                        <el-option
                            v-for="category in categoryList"
                            :key="category.id"
                            :label="category.categoryName"
                            :value="category.id"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="query.status" placeholder="请选择状态" clearable>
                        <el-option label="上架" :value="1"/>
                        <el-option label="下架" :value="0"/>
                    </el-select>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
                <el-button type="success" @click="btnInsert()">新增</el-button>
            </el-form>

            <el-table
                :data="dataList"
                border>
                <el-table-column type="index" label="编号" width="80"/>
                <el-table-column prop="goodsName" label="商品名称" show-overflow-tooltip/>
                <el-table-column prop="mainImage" label="商品图片" width="120">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.mainImage" :src="file_pre+scope.row.mainImage" style="width: 90px; height: 90px"
                                  fit="cover"/>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="price" label="价格" width="100"/>
                <el-table-column prop="stock" label="库存" width="100"/>
                <el-table-column prop="status" label="状态" width="80">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
                            {{ scope.row.status === 1 ? '上架' : '下架' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序" width="80"/>
                <el-table-column prop="createTime" label="创建时间" width="180"/>
                <el-table-column align="center" label="操作" width="210">
                    <template slot-scope="scope">
                        <el-button size="small" type="info" @click="btnUpdate(scope.row)">修改</el-button>
                        <el-button size="small" type="danger" @click="btnDelete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination style="margin-top:10px;"
                           background
                           layout="total,prev, pager, next"
                           @current-change="currentChange"
                           :current-page="query.currentPage"
                           :page-size="query.pageSize"
                           :total="total">
            </el-pagination>
        </el-card>

        <!-- 新增/编辑对话框 -->
        <el-dialog :close-on-click-modal="false" title="商品管理" :visible="isShowDialogFlag" @close="close" width="60%">
            <el-form label-width="120px" :model="data" ref="data" :rules="rules">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="商品名称" prop="goodsName">
                            <el-input v-model="data.goodsName" maxlength="50" auto-complete="off" placeholder="请输入商品名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商品分类" prop="categoryId">
                            <el-select v-model="data.categoryId" placeholder="请选择分类" style="width: 100%;">
                                <el-option
                                    v-for="category in categoryList"
                                    :key="category.id"
                                    :label="category.categoryName"
                                    :value="category.id"/>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="商品价格" prop="price">
                            <el-input-number v-model="data.price" :min="0" :precision="2" controls-position="right" style="width: 100%;"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="库存" prop="stock">
                            <el-input-number v-model="data.stock" :min="0" controls-position="right" style="width: 100%;"/>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="商品图片" prop="mainImage">
                    <square-crop-upload
                        v-model="data.mainImage"
                        :max-size="2048*5"
                        :auto-upload="true"
                    />
                    <div style="color: #999; font-size: 12px; margin-top: 5px;">建议尺寸：800x800px，支持JPG、PNG格式</div>
                </el-form-item>

                <el-form-item label="商品图集">
                    <multi-image-upload
                        v-model="data.images"
                        :max-size="2048*5"
                        :limit="9"
                        tips="支持多图上传，最多9张，建议尺寸：800x800px"
                    />
                </el-form-item>

                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="data.remark" maxlength="500" :rows="3" placeholder="请输入备注"></el-input>
                </el-form-item>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="状态" prop="status">
                            <el-radio-group v-model="data.status">
                                <el-radio :label="1">上架</el-radio>
                                <el-radio :label="0">下架</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="排序" prop="sort">
                            <el-input-number v-model="data.sort" :min="0" controls-position="right" style="width: 100%;"/>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="规格类型">
                    <el-radio-group v-model="data.specType" @change="handleSpecTypeChange">
                        <el-radio :label="1">单规格</el-radio>
                        <el-radio :label="2">多规格</el-radio>
                    </el-radio-group>
                </el-form-item>

                <!-- 多规格设置 -->
                <div v-if="data.specType === 2" style="border: 1px solid #dcdfe6; padding: 15px; border-radius: 4px; margin-bottom: 15px;">
                    <div style="margin-bottom: 15px; font-weight: bold;">选择规格项：</div>
                    <el-checkbox-group v-model="selectedSpecTemplates" @change="handleSpecTemplateChange">
                        <el-checkbox
                            v-for="template in specTemplates"
                            :key="template.id"
                            :label="template.id"
                            style="display: block; margin-bottom: 10px;">
                            {{ template.templateName }}
                        </el-checkbox>
                    </el-checkbox-group>

                    <!-- 已选择的规格项及其值 -->
                    <div v-for="spec in selectedSpecs" :key="spec.templateId" style="margin-top: 15px;">
                        <div style="font-weight: bold; margin-bottom: 10px;">{{ spec.templateName }}：</div>
                        <el-checkbox-group v-model="spec.selectedValues" @change="generateSkuList">
                            <el-checkbox
                                v-for="value in spec.values"
                                :key="value.id"
                                :label="value.id">
                                {{ value.valueName }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>

                    <!-- SKU列表表格 -->
                    <div v-if="skuList.length > 0" style="margin-top: 20px;">
                        <div style="font-weight: bold; margin-bottom: 10px;">SKU列表：</div>
                        <el-table :data="skuList" border size="small">
                            <el-table-column prop="specText" label="规格组合" width="200"/>
                            <el-table-column label="价格" width="150">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.price" :min="0" :precision="2" size="small" controls-position="right"
                                                     style="width: 100%;"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="库存" width="120">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.stock" :min="0" size="small" controls-position="right" style="width: 100%;"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="SKU编号" width="150">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.skuSn" size="small" placeholder="可选"/>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click='close'>取消</el-button>
                <el-button type="primary" class="title" @click="submitForm('data')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getGoodsPage, insertGoods, updateGoods, deleteGoods, getGoodsSkuList } from '@/api/ordering/goods'
import { getSpecTemplateList, getSpecValueList } from '@/api/ordering/spec'
import { getCategoryList } from '@/api/ordering/category'
import SquareCropUpload from '@/components/core/images/SquareCropUpload'
import MultiImageUpload from '@/components/core/images/MultiImageUpload'
import global from "@/api/global";

export default {
    name: 'GoodsList',
    components: {
        SquareCropUpload,
        MultiImageUpload
    },
    async created() {
        await this.load()
        await this.loadCategoryList()
        await this.loadSpecTemplates()
    },
    data() {
        return {
            file_pre: global.preview_path_url,
            total: 0,
            dataList: [],
            query: {
                currentPage: 1,
                pageSize: 10,
                goodsName: undefined,
                categoryId: undefined,
                status: undefined
            },
            isShowDialogFlag: false,
            data: {
                id: null,
                goodsName: null,
                categoryId: null,
                price: 0,
                stock: 0,
                mainImage: null,  // 与后端字段名保持一致
                images: [],
                remark: null,  // 使用后端字段名
                status: 1,
                sort: 1,
                specType: 1 // 1-单规格，2-多规格
            },
            rules: {
                goodsName: [
                    {required: true, message: '请输入商品名称', trigger: 'blur'}
                ],
                categoryId: [
                    {required: true, message: '请选择商品分类', trigger: 'change'}
                ],
                price: [
                    {required: true, message: '请输入商品价格', trigger: 'blur'}
                ],
                stock: [
                    {required: true, message: '请输入库存数量', trigger: 'blur'}
                ]
            },
            // 规格相关
            specTemplates: [], // 规格模板列表
            selectedSpecTemplates: [], // 已选择的规格模板ID列表
            selectedSpecs: [], // 已选择的规格 [{templateId, templateName, values: [{id, name}]}]
            skuList: [], // SKU列表
            categoryList: [] // 分类列表
        }
    },
    methods: {
        async load() {
            this.dataList = []
            let res = await getGoodsPage(this.query)
            this.dataList = res.records || []
            this.total = res.total || 0
        },
        currentChange(num) {
            this.query.currentPage = num
            this.load()
        },
        btnInsert() {
            this.data = {
                id: null,
                goodsName: null,
                categoryId: null,
                price: 0,
                stock: 0,
                mainImage: null,
                images: [],
                remark: null,
                status: 1,
                sort: 1,
                specType: 1
            }
            this.selectedSpecTemplates = []
            this.selectedSpecs = []
            this.skuList = []
            this.isShowDialogFlag = true
        },
        async btnUpdate(row) {
            this.data = JSON.parse(JSON.stringify(row))

            // ✅ 处理商品图集数据（后端返回的是JSON字符串）
            if (this.data.images && typeof this.data.images === 'string') {
                try {
                    const imagesArray = JSON.parse(this.data.images)
                    // 直接使用URL数组，MultiImageUpload 组件会自动处理显示
                    this.data.images = imagesArray
                } catch (e) {
                    console.error('解析商品图集失败', e)
                    this.data.images = []
                }
            } else if (!this.data.images) {
                this.data.images = []
            }

            // 如果是多规格商品，加载SKU数据并回填规格选择
            if (row.specType === 2) {
                try {
                    const skuList = await getGoodsSkuList(row.id)
                    this.skuList = skuList || []

                    // 根据SKU数据回填规格选择
                    if (this.skuList.length > 0) {
                        this.restoreSpecSelectionFromSkus(this.skuList)
                    } else {
                        this.selectedSpecTemplates = []
                        this.selectedSpecs = []
                    }
                } catch (error) {
                    console.error('加载SKU失败', error)
                    this.selectedSpecTemplates = []
                    this.selectedSpecs = []
                    this.skuList = []
                }
            } else {
                this.selectedSpecTemplates = []
                this.selectedSpecs = []
                this.skuList = []
            }

            this.isShowDialogFlag = true
        },
        async close() {
            this.isShowDialogFlag = false
            if (this.$refs.data) {
                this.$refs.data.clearValidate()
            }
            // 清空规格相关数据
            this.selectedSpecTemplates = []
            this.selectedSpecs = []
            this.skuList = []
            // 清空图片数据
            this.data.mainImage = null
            this.data.images = []
        },
        async submitForm(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    try {
                        // 处理图片数据
                        const submitData = {...this.data}

                        console.log('提交前的图片数据:', submitData.images)
                        console.log('提交前的主图:', submitData.mainImage)

                        // ✅ 确保 mainImage 字段存在且不为 undefined
                        if (!submitData.mainImage) {
                            submitData.mainImage = ''
                        }

                        // 将商品图集列表转换为JSON字符串
                        if (submitData.images && Array.isArray(submitData.images) && submitData.images.length > 0) {
                            // 提取所有图片的URL
                            const imageUrls = submitData.images.map(img => {
                                // 如果img是对象且有url属性，取url；否则直接返回img（可能是字符串）
                                return typeof img === 'object' ? (img.url || img.response?.data) : img
                            }).filter(url => url) // 过滤掉空值

                            if (imageUrls.length > 0) {
                                submitData.images = JSON.stringify(imageUrls)
                            } else {
                                submitData.images = null
                            }
                        } else {
                            submitData.images = null
                        }

                        console.log('提交时的images字段:', submitData.images)
                        console.log('提交时的mainImage字段:', submitData.mainImage)

                        // 如果是单规格，设置默认库存和价格
                        if (submitData.specType === 1) {
                            submitData.stock = submitData.stock || 0
                        }

                        // 如果是多规格，将SKU列表添加到提交数据中
                        if (submitData.specType === 2) {
                            submitData.skuList = this.skuList
                        }

                        console.log('最终提交的数据:', submitData)

                        // 保存商品（包含SKU）
                        let result = !submitData.id ? await insertGoods(submitData) : await updateGoods(submitData)

                        console.log('保存结果:', result)

                        this.$message.success('操作成功')
                        await this.close()
                        await this.load()
                    } catch (error) {
                        console.error('保存失败', error)
                        this.$message.error('保存失败: ' + (error.message || '未知错误'))
                    }
                }
            })
        },
        async btnDelete(id) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await deleteGoods(id)
                this.$message.success('操作成功')
                this.query.currentPage = 1
                await this.load()
            })
        },
        // 加载分类列表
        async loadCategoryList() {
            try {
                const res = await getCategoryList()
                this.categoryList = res || []
            } catch (error) {
                console.error('加载分类列表失败', error)
            }
        },
        // 加载规格模板列表
        async loadSpecTemplates() {
            try {
                const res = await getSpecTemplateList()
                this.specTemplates = res || []
            } catch (error) {
                console.error('加载规格模板失败', error)
            }
        },
        // 处理图片变化
        // 规格类型改变
        handleSpecTypeChange(val) {
            if (val === 1) {
                this.selectedSpecs = []
                this.skuList = []
            }
        },
        // 处理规格模板选择变化
        async handleSpecTemplateChange(selectedIds) {
            this.selectedSpecs = []
            for (let templateId of selectedIds) {
                const template = this.specTemplates.find(t => t.id === templateId)
                if (template) {
                    try {
                        const values = await getSpecValueList(templateId)
                        this.selectedSpecs.push({
                            templateId: template.id,
                            templateName: template.templateName,
                            values: values || [],
                            selectedValues: []
                        })
                    } catch (error) {
                        console.error('加载规格值失败', error)
                    }
                }
            }
            this.generateSkuList()
        },
        // 生成SKU列表
        generateSkuList() {
            if (this.selectedSpecs.length === 0) {
                this.skuList = []
                return
            }

            // 检查是否所有规格都选择了值
            const allSelected = this.selectedSpecs.every(spec => spec.selectedValues.length > 0)
            if (!allSelected) {
                this.skuList = []
                return
            }

            // 保存旧的SKU数据，用于恢复用户输入
            const oldSkuMap = new Map()
            this.skuList.forEach(sku => {
                oldSkuMap.set(sku.specText, {
                    price: sku.price,
                    stock: sku.stock,
                    skuSn: sku.skuSn
                })
            })

            // 笛卡尔积生成SKU组合
            const combinations = this.cartesianProduct(this.selectedSpecs.map(spec =>
                spec.selectedValues.map(valId => {
                    const value = spec.values.find(v => v.id === valId)
                    return {templateId: spec.templateId, valueId: valId, valueName: value.valueName}
                })
            ))

            this.skuList = combinations.map((combo, index) => {
                const specValues = combo.map(item => item.valueId)
                const specNames = combo.map(item => item.valueName)
                const specText = specNames.join('/')

                // 尝试从旧数据中恢复用户输入
                const oldData = oldSkuMap.get(specText) || {}

                return {
                    skuSn: oldData.skuSn || '',
                    specValues: JSON.stringify(specValues),
                    specNames: JSON.stringify(specNames),
                    specText: specText,
                    price: oldData.price !== undefined ? oldData.price : (this.data.price || 0),
                    stock: oldData.stock !== undefined ? oldData.stock : (this.data.stock || 0),
                    sort: index + 1
                }
            })
        },
        // 从SKU数据恢复规格选择状态
        restoreSpecSelectionFromSkus(skuList) {
            // 收集所有出现过的规格模板ID和规格值ID
            const templateIdSet = new Set()
            const specValueMap = new Map() // templateId -> Set of valueIds

            skuList.forEach(sku => {
                if (sku.specValues) {
                    try {
                        const specValues = JSON.parse(sku.specValues)
                        const specNames = JSON.parse(sku.specNames)

                        // 假设specValues和specNames的顺序对应规格模板的顺序
                        // 需要从第一个SKU中提取规格模板信息
                        if (!this.firstSkuProcessed) {
                            this.firstSkuProcessed = true
                            // 这里需要根据实际业务逻辑来确定规格模板
                            // 暂时从后端返回的SKU数据中提取
                        }

                        specValues.forEach((valueId, index) => {
                            // 这里需要一个映射关系：valueId -> templateId
                            // 由于前端没有这个映射，我们需要从后端获取或者通过其他方式推断
                            // 暂时使用简化的方式：遍历所有规格模板，找到包含该valueId的模板
                            this.specTemplates.forEach(template => {
                                // 需要加载该模板的所有规格值来检查
                                if (!specValueMap.has(template.id)) {
                                    specValueMap.set(template.id, new Set())
                                }
                            })
                        })
                    } catch (e) {
                        console.error('解析规格数据失败', e)
                    }
                }
            })

            // 由于上述方法复杂度高，采用更简单的方式：
            // 直接从SKU的specNames字段提取规格名称，然后匹配规格模板和值
            this.restoreSpecSelectionByNames(skuList)
        },

        // 通过规格名称恢复规格选择
        async restoreSpecSelectionByNames(skuList) {
            if (!skuList || skuList.length === 0) return

            try {
                // 收集所有SKU中的所有规格名称（去重）
                const allSpecNamesSet = new Set()
                skuList.forEach(sku => {
                    if (sku.specNames) {
                        try {
                            const specNames = JSON.parse(sku.specNames)
                            specNames.forEach(name => allSpecNamesSet.add(name))
                        } catch (e) {
                            console.error('解析specNames失败', e)
                        }
                    }
                })

                const allSpecNames = Array.from(allSpecNamesSet)
                console.log('收集到的所有规格名称:', allSpecNames)

                // ✅ 优化：先批量加载所有模板的规格值（避免重复调用）
                const templateValuesMap = new Map() // templateId -> values
                for (let template of this.specTemplates) {
                    try {
                        const values = await getSpecValueList(template.id)
                        templateValuesMap.set(template.id, values || [])
                        console.log(`加载模板 ${template.templateName} 的规格值:`, values?.length || 0, '个')
                    } catch (e) {
                        console.error('加载规格值失败', e)
                        templateValuesMap.set(template.id, [])
                    }
                }

                // 对于每个规格名称，在已加载的数据中查找
                const selectedTemplateIds = []
                const specsToRestore = []

                for (let specName of allSpecNames) {
                    // 在所有规格模板中查找包含该规格值的模板
                    for (let template of this.specTemplates) {
                        const values = templateValuesMap.get(template.id)
                        if (values && values.length > 0) {
                            // 检查该模板是否包含这个规格值
                            const matchedValue = values.find(v => v.valueName === specName)
                            if (matchedValue) {
                                if (!selectedTemplateIds.includes(template.id)) {
                                    selectedTemplateIds.push(template.id)
                                }

                                // 添加到待恢复列表
                                let existingSpec = specsToRestore.find(s => s.templateId === template.id)
                                if (!existingSpec) {
                                    existingSpec = {
                                        templateId: template.id,
                                        templateName: template.templateName,
                                        values: values,
                                        selectedValues: []
                                    }
                                    specsToRestore.push(existingSpec)
                                }

                                // 添加选中的值（避免重复）
                                if (!existingSpec.selectedValues.includes(matchedValue.id)) {
                                    existingSpec.selectedValues.push(matchedValue.id)
                                }

                                console.log(`匹配到规格: ${template.templateName} -> ${specName} (ID: ${matchedValue.id})`)
                                break // 找到后跳出模板循环
                            }
                        }
                    }
                }

                console.log('选中的规格模板IDs:', selectedTemplateIds)
                console.log('恢复的规格数据:', specsToRestore)

                // 设置选中的规格模板
                this.selectedSpecTemplates = selectedTemplateIds

                // 设置选中的规格和值
                this.selectedSpecs = specsToRestore

                // 重新生成SKU列表（会保留用户之前输入的价格、库存等）
                this.generateSkuList()

                // 将后端返回的SKU数据合并到生成的SKU列表中
                this.mergeSkuData(skuList)

            } catch (e) {
                console.error('恢复规格选择失败', e)
            }
        },

        // 合并后端SKU数据到前端SKU列表
        mergeSkuData(backendSkuList) {
            if (!backendSkuList || backendSkuList.length === 0) return

            // 创建一个映射：specText -> 后端SKU数据
            const backendSkuMap = new Map()
            backendSkuList.forEach(sku => {
                if (sku.specText) {
                    backendSkuMap.set(sku.specText, sku)
                }
            })

            // 将后端数据合并到前端SKU列表
            this.skuList.forEach(frontendSku => {
                const backendSku = backendSkuMap.get(frontendSku.specText)
                if (backendSku) {
                    // 如果前端SKU没有价格或库存，使用后端的数据
                    if (!frontendSku.price || frontendSku.price === 0) {
                        frontendSku.price = backendSku.price || 0
                    }
                    if (!frontendSku.stock && frontendSku.stock !== 0) {
                        frontendSku.stock = backendSku.stock || 0
                    }
                    if (!frontendSku.skuSn) {
                        frontendSku.skuSn = backendSku.skuSn || ''
                    }
                }
            })
        },
        // 笛卡尔积算法
        cartesianProduct(arrays) {
            return arrays.reduce((acc, curr) => {
                return acc.flatMap(a => curr.map(b => [...a, b]))
            }, [[]])
        },
    }
}
</script>

<style scoped>
.content_div {
    padding: 20px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

/* 多图上传样式 */
.el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
}

.el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
}

/* 弹窗内容间距优化 */
::v-deep .el-dialog__body {
    padding: 20px 30px;
}

/* 弹窗头部间距 */
::v-deep .el-dialog__header {
    padding: 20px 30px 15px;
    margin-right: 0;
}

/* 弹窗底部间距 */
::v-deep .el-dialog__footer {
    padding: 15px 30px 20px;
}

/* 表单项间距 */
::v-deep .el-form-item {
    margin-bottom: 20px;
}
</style>
